import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRouters = ({isAuthenticated}) =>{
    console.log("In private Router Component",isAuthenticated);
    if(!isAuthenticated){
        return <Navigate to="/"/>
    }
    
    return <Outlet/>
};

export default PrivateRouters;